import React from 'react';
import { textoEfectos } from '../arena';

// Habilidades, armas y mascotas de la arena (apps/arena/arena.js, guardarObjeto). De momento solo se
// configuran: se consiguen al subir de tier y se equipan en Mi cuenta, pero el combate no las usa.
// Mismo esquema que AdminEventos.

const TIPOS = [['habilidad', 'Habilidad'], ['arma', 'Arma'], ['mascota', 'Mascota']];
const STATS = [['vida', 'Vida'], ['ataque', 'Ataque'], ['agilidad', 'Agilidad'], ['velocidad', 'Velocidad']];
const AYUDA = {
    habilidad: 'Pasiva: una vez conseguida se aplica siempre. Escribe el % sobre cada stat (+10%, -5%).',
    arma: 'Mientras está equipada, durante sus usos (al azar entre el mínimo y el máximo). Escribe x3 para multiplicar, +2 o -2 para sumar, -50% en porcentaje.',
    mascota: 'Sale desde el principio del combate y los luchadores van a por ella. 10% = el 10 % de esa stat de su dueño; 30 = valor fijo.'
};
const EJEMPLO = { habilidad: '+10%', arma: 'x3, -2, -50%', mascota: '10% o 30' };
const EMPTY = { tipo: 'habilidad', nombre: '', descripcion: '', efectos: {}, usosMin: 1, usosMax: 1 };

const AdminArena = () => {
    const [form, setForm] = React.useState(EMPTY);
    const [image, setImage] = React.useState(null);
    const [editingId, setEditingId] = React.useState(null);
    const [objetos, setObjetos] = React.useState(null);
    const [status, setStatus] = React.useState({ text: '', type: '' });
    const [loading, setLoading] = React.useState(false);
    const fileRef = React.useRef(null);
    const aviso = (text, type) => setStatus({ text, type });

    const refresh = React.useCallback(async () => {
        const res = await fetch('/api/arenaAdmin').then(r => r.json()).catch(() => null);
        if (res && res.objetos) setObjetos(res.objetos);
        else setStatus({ text: 'No se pudieron leer', type: 'error' });
    }, []);
    React.useEffect(() => { refresh(); }, [refresh]);

    const resetForm = () => {
        setForm(EMPTY);
        setImage(null);
        setEditingId(null);
        if (fileRef.current) fileRef.current.value = '';
    };

    const handleImage = (e) => {
        const file = e.target.files && e.target.files[0];
        if (file && file.size > 2 * 1024 * 1024) {
            aviso('La imagen pasa de 2 MB', 'error');
            e.target.value = '';
            return;
        }
        setImage(file || null);
    };

    const handleSave = async () => {
        setLoading(true);
        aviso('', '');
        const data = new FormData();
        if (editingId) data.append('id', editingId);
        ['tipo', 'nombre', 'descripcion', 'usosMin', 'usosMax'].forEach(k => data.append(k, form[k]));
        data.append('efectos', JSON.stringify(form.efectos));
        if (image) data.append('imagen', image);
        try {
            const res = await fetch('/api/arenaAdmin/guardar', { method: 'POST', body: data }).then(r => r.json());
            if (res && res.objeto) {
                aviso(editingId ? 'Guardado.' : '"' + res.objeto.nombre + '" creado.', 'success');
                resetForm();
                await refresh();
            } else {
                aviso((res && res.error) || 'No se pudo guardar', 'error');
            }
        } catch (err) {
            aviso('No se pudo guardar', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (o) => {
        setEditingId(o.id);
        setForm({ tipo: o.tipo, nombre: o.nombre, descripcion: o.descripcion, efectos: o.efectos, usosMin: o.usosMin || 1, usosMax: o.usosMax || 1 });
        setImage(null);
        if (fileRef.current) fileRef.current.value = '';
        aviso('', '');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleDelete = async (o) => {
        if (!window.confirm('¿Borrar "' + o.nombre + '"? Quien la tenga la pierde.')) return;
        const res = await fetch('/api/arenaAdmin/borrar', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: o.id })
        }).then(r => r.json()).catch(() => null);
        aviso(res && res.ok ? 'Borrado.' : (res && res.error) || 'No se pudo borrar', res && res.ok ? 'success' : 'error');
        if (editingId === o.id) resetForm();
        await refresh();
    };

    const field = (k) => ({ value: form[k], onChange: (e) => setForm({ ...form, [k]: e.target.value }) });

    return (
        <div className='heroes formOver'>
            <h1>Arena</h1>
            <p style={{ fontSize: 13, color: '#ccc', fontFamily: 'Arial, Helvetica, sans-serif' }}>
                Habilidades, armas y mascotas de la arena. De momento <strong>no cambian nada en los combates</strong>: solo
                se configuran. Todos empiezan en tier 1; al subir de tier, el luchador vuelve a nivel 1 con las stats con las que
                empezó a cambio de una de 3 al azar. Por ahora solo
                puede subir de tier naruxforall con la sesión de admin abierta, y hace falta que haya al menos 3 que aún no tenga.
            </p>

            <h2>{editingId ? 'Editar' : 'Nueva'}</h2>
            <div className='formFieldRow'>
                <label className='formFieldLabel heroes'>Tipo</label>
                <select className='userSearch' disabled={!!editingId} {...field('tipo')}>
                    {TIPOS.map(([k, nombre]) => <option key={k} value={k}>{nombre}</option>)}
                </select>
            </div>
            <div className='formFieldRow'>
                <label className='formFieldLabel heroes'>Nombre</label>
                <input className='userSearch' maxLength={60} {...field('nombre')} />
            </div>
            <div className='formFieldRow'>
                <label className='formFieldLabel heroes'>Descripción</label>
                <textarea className='userSearch' rows='2' maxLength={300} {...field('descripcion')} />
            </div>
            <p style={{ fontSize: 13, color: '#ccc', fontFamily: 'Arial, Helvetica, sans-serif' }}>{AYUDA[form.tipo]} Vacío = no la toca.</p>
            {STATS.map(([k, nombre]) => (
                <div key={k} className='formFieldRow'>
                    <label className='formFieldLabel heroes'>{nombre}</label>
                    <input className='userSearch' placeholder={EJEMPLO[form.tipo]} value={form.efectos[k] || ''}
                        onChange={(e) => setForm({ ...form, efectos: { ...form.efectos, [k]: e.target.value } })} />
                </div>
            ))}
            {form.tipo === 'arma' ? (
                <div className='formFieldRow'>
                    <label className='formFieldLabel heroes'>Usos (mínimo y máximo)</label>
                    <input className='userSearch' type='number' min='1' max='99' {...field('usosMin')} onWheel={(e) => e.currentTarget.blur()} />
                    <input className='userSearch' type='number' min='1' max='99' {...field('usosMax')} onWheel={(e) => e.currentTarget.blur()} />
                </div>
            ) : null}
            <div className='formFieldRow'>
                <label className='formFieldLabel heroes'>{editingId ? 'Imagen (vacía = la misma)' : 'Imagen'}</label>
                <input className='userSearch' type='file' accept='image/*' ref={fileRef} onChange={handleImage} />
            </div>
            <div className='navTops heroes unselectable'>
                <div onClick={() => { if (!loading) handleSave(); }}>{editingId ? 'Guardar cambios' : 'Crear'}</div>
                {editingId ? <div onClick={() => { if (!loading) resetForm(); }}>Cancelar</div> : null}
            </div>

            {TIPOS.map(([tipo, nombre]) => {
                const lista = (objetos || []).filter(o => o.tipo === tipo);
                return (
                    <React.Fragment key={tipo}>
                        <h2>{nombre === 'Habilidad' ? 'Habilidades' : nombre + 's'}</h2>
                        {!objetos ? <p>Cargando...</p> : !lista.length ? <p>Todavía no hay ninguna.</p> : lista.map(o => (
                            <div key={o.id} className='formFieldRow' style={{ alignItems: 'center' }}>
                                {o.imagen ? <img src={o.imagen} alt='' style={{ width: 56, height: 56, objectFit: 'contain', marginRight: 12 }} /> : null}
                                <span style={{ flex: 1 }}>
                                    <strong>{o.nombre}</strong>
                                    <span style={{ fontSize: 13, color: '#ccc' }}>{' · ' + (textoEfectos(o) || 'sin efectos')}</span>
                                    {o.descripcion ? <><br /><span style={{ fontSize: 13, color: '#ccc' }}>{o.descripcion}</span></> : null}
                                </span>
                                <div className='miniBtn heroes unselectable' onClick={() => { if (!loading) handleEdit(o); }}>Editar</div>
                                <div className='miniBtn heroes unselectable' onClick={() => { if (!loading) handleDelete(o); }}>Borrar</div>
                            </div>
                        ))}
                    </React.Fragment>
                );
            })}

            {loading ? <p>Cargando...</p> : null}
            {status.text ? (
                <p
                    role={status.type === 'error' ? 'alert' : 'status'}
                    style={{
                        padding: '8px 12px',
                        borderRadius: 4,
                        fontWeight: 600,
                        color: status.type === 'success' ? '#0a6b0a' : '#8a1a1a',
                        backgroundColor: status.type === 'success' ? '#d9f5d9' : '#fdecea'
                    }}
                >
                    {status.text}
                </p>
            ) : null}
        </div>
    );
};

export default AdminArena;
